import { render, staticRenderFns } from "./AreaManagersPageIndex.vue?vue&type=template&id=b3d817b0&"
import script from "./AreaManagersPageIndex.vue?vue&type=script&lang=ts&"
export * from "./AreaManagersPageIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3d817b0')) {
      api.createRecord('b3d817b0', component.options)
    } else {
      api.reload('b3d817b0', component.options)
    }
    module.hot.accept("./AreaManagersPageIndex.vue?vue&type=template&id=b3d817b0&", function () {
      api.rerender('b3d817b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/AreaManagers/AreaManagersPageIndex.vue"
export default component.exports